<template>
  <!---全体を囲む--->
  <div class="content-wrapper">
    <TemplateBook v-if="isReadyToDraw" />

    <!-- 描画ローディング -->
    <DialogInitialLoading v-else />

    <DialogHasExchangeableCoupon ref="DialogHasExchangeableCoupon" />
  </div>
</template>

<script>
import TemplateBook from "@/views/Templates/MyTickets/TemplateBook";

import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

import mfittService from "@/services/MFITT";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "Book",
  components: {
    TemplateBook: TemplateBook,
  },

  setup() {
    const store = useStore();
    const route = useRoute();

    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const myCoupons = computed(() => store.getters["MFITT/myCoupons"]);

    const isReadyToDraw = ref(false);

    const DialogHasExchangeableCoupon = ref(null);

    const openDialogIfHasExchangeableCoupon = () => {
      if (
        mfittService.checkHasExchangeableCouponsWithBook(
          myCoupons.value,
          book.value.id
        )
      ) {
        DialogHasExchangeableCoupon.value.openDialog();
      }
    };

    onMounted(async () => {
      try {
        await Promise.all([
          API.getMyticketDetail(route.params.book_group_id),
          API.getMyCoupons(),
        ]);

        openDialogIfHasExchangeableCoupon();

        isReadyToDraw.value = true;
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "Book onMounted()",
          JSON.stringify(err)
        );
        console.log("error in Book", err);
      }
    });

    return {
      isReadyToDraw,
      masterBook,
      DialogHasExchangeableCoupon,
    };
  },
};
</script>
